// extracted by mini-css-extract-plugin
export default {"card":"FileReader_card__20d-K","objecttag":"FileReader_objecttag__Z7W6e"};